import type { RouteRecordRaw } from 'vue-router';

export const routes: RouteRecordRaw[] = [
  {
    name: 'login',
    path: '/login',
    component: () => import('../pages/LoginPage.vue')
  },
  {
    name: 'persons',
    path: '/persons',
    component: () => import('../pages/LoginPage.vue')
  },
  {
    name: 'resetPassword',
    path: '/reset-password',
    component: () => import('../pages/ResetPasswordPage.vue')
  }
];

export const mainRoutes: RouteRecordRaw[] = [
  {
    name: 'personalData',
    path: '/personal-data',
    component: () => import('../pages/PersonalDataPage.vue'),
    meta: {
      requiresAuth: true
    }
  }
];

export default { routes, mainRoutes };
